import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';
import Layout from './components/Layout/Layout';

import Home from './pages/Home';
import Portfolio from './pages/Portfolio';
import ProjectDetail from './pages/ProjectDetail';
import HomeTaxProCaseStudy from './pages/case-studies/HomeTaxProCaseStudy';
import AIShadowCaseStudy from './pages/case-studies/AIShadowCaseStudy';
import MyMedicalCabinetCaseStudy from './pages/case-studies/MyMedicalCabinetCaseStudy';
import SexySelfiesCaseStudy from './pages/case-studies/SexySelfiesCaseStudy';
import ASAHealthMDCaseStudy from './pages/case-studies/ASAHealthMDCaseStudy';
import PagomigoCaseStudy from './pages/case-studies/PagomigoCaseStudy';
import GraceToChangeCaseStudy from './pages/case-studies/GraceToChangeCaseStudy';
import BabyBunnyResaleCaseStudy from './pages/case-studies/BabyBunnyResaleCaseStudy';
import Templates from './pages/Templates';
import TemplateDetail from './pages/TemplateDetail';
import TemplateSuccess from './pages/TemplateSuccess';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import About from './pages/About';
import Pricing from './pages/Pricing';
import Contact from './pages/Contact';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import RefundPolicy from './pages/RefundPolicy';
import Disclaimer from './pages/Disclaimer';
import NotFound from './pages/NotFound';
import AdminLogin from './pages/Admin/AdminLogin';
import AdminDashboard from './pages/Admin/AdminDashboard';
import AdminProjects from './pages/Admin/AdminProjects';
import AdminTemplates from './pages/Admin/AdminTemplates';
import AdminBlog from './pages/Admin/AdminBlog';
import AdminContacts from './pages/Admin/AdminContacts';
import ProtectedRoute from './components/ProtectedRoute';

// Initialize Google Analytics
ReactGA.initialize('G-3T66HX1VLM');

function App() {
  const location = useLocation();

  // Track page views on route change
  useEffect(() => {
    ReactGA.send({ hitType: 'pageview', page: location.pathname + location.search });
  }, [location]);

  // Scroll to top on route change. React Router preserves scroll
  // position by default across client-side navigations, which on a
  // marketing site means clicking Portfolio from halfway down the
  // homepage lands the user in the middle of the portfolio page.
  // Fires only on pathname change so hash-anchor navigation (e.g.
  // /#services) still lets the browser handle in-page scroll.
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="portfolio" element={<Portfolio />} />
        {/* Hand-crafted case-study pages. Declared before the generic
            /portfolio/:slug route so React Router picks these explicit
            matches over the API-driven ProjectDetail fallback. */}
        <Route path="portfolio/hometaxpro" element={<HomeTaxProCaseStudy />} />
        <Route path="portfolio/aishadow" element={<AIShadowCaseStudy />} />
        <Route path="portfolio/mymedicalcabinet" element={<MyMedicalCabinetCaseStudy />} />
        <Route path="portfolio/sexyselfies" element={<SexySelfiesCaseStudy />} />
        <Route path="portfolio/asahealthmd" element={<ASAHealthMDCaseStudy />} />
        <Route path="portfolio/pagomigo" element={<PagomigoCaseStudy />} />
        <Route path="portfolio/gracetochange" element={<GraceToChangeCaseStudy />} />
        <Route path="portfolio/babybunnyresale" element={<BabyBunnyResaleCaseStudy />} />
        <Route path="portfolio/:slug" element={<ProjectDetail />} />
        <Route path="templates" element={<Templates />} />
        <Route path="templates/:slug" element={<TemplateDetail />} />
        <Route path="templates/success" element={<TemplateSuccess />} />
        <Route path="about" element={<About />} />
        <Route path="pricing" element={<Pricing />} />
        <Route path="contact" element={<Contact />} />
        <Route path="terms-of-service" element={<TermsOfService />} />
        <Route path="privacy-policy" element={<PrivacyPolicy />} />
        <Route path="refund-policy" element={<RefundPolicy />} />
        <Route path="disclaimer" element={<Disclaimer />} />
        <Route path=":slug" element={<BlogPost />} />
        <Route path="*" element={<NotFound />} />
      </Route>
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<ProtectedRoute />}>
        <Route index element={<AdminDashboard />} />
        <Route path="projects" element={<AdminProjects />} />
        <Route path="templates" element={<AdminTemplates />} />
        <Route path="blog" element={<AdminBlog />} />
        <Route path="contacts" element={<AdminContacts />} />
      </Route>
    </Routes>
  );
}

export default App;
